import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

import { CardDisplay } from './display';
import { useBoardCard } from './useBoardCard';

export const Card = ({ card, columnId, CardComponent, disableVerticalDragging }) => {
  const { state, outerRef, innerRef } = useBoardCard({ card, columnId, disableVerticalDragging });

  return (
    <>
      <CardDisplay CardComponent={CardComponent} outerRef={outerRef} innerRef={innerRef} state={state} card={card} />
      {state.type === 'preview'
        ? createPortal(<CardDisplay state={state} card={card} CardComponent={CardComponent} />, state.container)
        : null}
    </>
  );
};

Card.propTypes = {
  card: PropTypes.object.isRequired,
  columnId: PropTypes.string.isRequired,
  CardComponent: PropTypes.func.isRequired,
  disableVerticalDragging: PropTypes.bool,
};

Card.defaultProps = {
  disableVerticalDragging: false,
};
